import ApiService from "api/ApiService";

interface GetProjectDashboardDataResponse {
  success: boolean;
  messsage?: string;
  start_date_hourly: string;
  hourly_requests: number[];
  hourly_credits_spent: number[];
  start_date_daily: string;
  daily_requests: number[];
  daily_credits_spent: number[];
  daily_average_latency: number[];
  total_requests_past_day: number;
  total_credits_spent_past_day: number;
  total_requests_curr_hour: number;
  total_credits_spent_curr_hour: number;
}

export default class ProjectDashboardService {
  private static getProjectUrl(): string {
    return "api/projects";
  }

  public static async getProjectDashboardData(
    project_id: string,
  ): Promise<GetProjectDashboardDataResponse> {
    try {
      const response = await ApiService.request(
        {
          url: `${this.getProjectUrl()}/${project_id}/dashboard`,
          method: "GET",
        },
        true,
      );
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
